<script setup lang="ts">
  import { provide } from 'vue'
  import { accessRolesCollectionKey } from '@gat-ship/types/injection-keys'
  import { useAccessRolesCollection } from '../../composables/useAccessRolesCollection'

  const props = withDefaults(
    defineProps<{
      fetchOnMount?: boolean
    }>(),
    {
      fetchOnMount: false
    }
  )

  const dataSource = useAccessRolesCollection()

  if (props.fetchOnMount) {
    dataSource.fetchAccessRoles()
  }

  provide(accessRolesCollectionKey, dataSource)
  defineExpose(dataSource)
</script>

<template>
  <slot />
</template>
